<div class="container" #container>

</div>
@if (analysis.result()) {
  <div class="analysis-legend">
    <cr-analysis-legend [floating]="false"></cr-analysis-legend>
  </div>
}
